<template>
  <div>
    <h1>公司风貌</h1>
    <div class="carousel" v-if="images.length">
      <!-- 主图 -->
      <div class="carousel-main" style="margin-top: 50px;">
        <img
          :src="images[currentIndex].image_path"
          :alt="'Image ' + currentIndex"
          class="main-image"
        />
      </div>

      <!-- 控制按钮 & 缩略图 -->
      <div class="carousel-controls" style="margin-top: 50px;">
        <button @click="prevImage" class="carousel-button">&lt;</button>
        <div class="thumbnails">
          <img
            v-for="(image, index) in images"
            :key="index"
            :src="image.image_path"
            :alt="'Thumbnail ' + index"
            @click="currentIndex = index"
            :class="{ active: index === currentIndex }"
            class="thumbnail"
          />
        </div>
        <button @click="nextImage" class="carousel-button">&gt;</button>
      </div>
    </div>
    <div v-else>
      <p>暂无风貌照片</p>
    </div>
  </div>
</template>

<script>
import { getAllLandscapes } from "@/api/landscape";

export default {
  name: "Culture",
  data() {
    return {
      images: [],
      currentIndex: 0,
      autoPlayInterval: null,
    };
  },
  methods: {
    async fetchAllLandscapes() {
      try {
        const res = await getAllLandscapes();
        if (res.data.status === 200 && Array.isArray(res.data.data.list)) {
          // 映射成包含 image_path 的数组，并确保完整 URL
          this.images = res.data.data.list.map((item) => ({
            image_path: item.image_path.startsWith("http")
              ? item.image_path
              : this.$serverUrl + item.image_path,
            remark: item.remark || "",
          }));
          console.log("全部风貌照片:", this.images);
        } else {
          console.error("获取风貌失败:", res.data.msg);
        }
      } catch (err) {
        console.error("请求异常:", err);
      }
    },
    nextImage() {
      if (this.images.length) {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      }
    },
    prevImage() {
      if (this.images.length) {
        this.currentIndex =
          (this.currentIndex - 1 + this.images.length) % this.images.length;
      }
    },
    startAutoPlay() {
      if (!this.autoPlayInterval && this.images.length > 1) {
        this.autoPlayInterval = setInterval(this.nextImage, 5000);
      }
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    },
  },
  mounted() {
    this.fetchAllLandscapes().then(() => {
      this.startAutoPlay();
    });
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
};
</script>

<style scoped>
.carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-main {
  position: relative;
}

.main-image {
  width: 100%;
  max-width: 600px;
  height: auto;
  transition: opacity 0.5s ease-in-out;
  border-radius: 5px;
}

.carousel-controls {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.carousel-button {
  background-color: #e0e0e0;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 1.5em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
  transition: background-color 0.3s;
}

.carousel-button:hover {
  background-color: #cccccc;
}

.thumbnails {
  display: flex;
  overflow-x: auto;
  max-width: 400px;
}

.thumbnail {
  width: 60px;
  height: 40px;
  object-fit: cover;
  margin: 0 5px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
  border-radius: 3px;
}

.thumbnail.active,
.thumbnail:hover {
  opacity: 1;
  border: 2px solid #409eff;
}
</style>
